import axios, { AxiosResponse } from 'axios';
import { formatoFecha, function_capitalize, parseo_mes } from 'components/Admin/Inicio-Admin/Dashboard_Individual_Admin';
import Cargando from 'components/Varios/Cargando';
import React, { useEffect, useState } from 'react'
//Reactstrap
import { Button, Card, CardTitle, CardBody, CardFooter, Container, Row, Col, Table } from "reactstrap";
import { authenticationService } from 'services/authentication.service';
//URL
import configData from "../../../config.json";
//Componentes 
import DataTable, { Alignment, TableColumn } from 'react-data-table-component';
//Modal
import ModalDirectivo, { Planificacion_Vacaciones, PRIMER_APROBADOR, SEGUNDO_APROBADOR, UNICO_APROBADOR } from './ModalDirectivo';
import { ESTADO_APROBACION_PARCIAL, ESTADO_APROBADO, ESTADO_ENVIADO_TALENTO_HUMANO, ESTADO_NO_HA_PLANIFICADO, ESTADO_PENDIENTE, ESTADO_RECHAZADO, ESTADO_TIENE_RECHAZADAS, function_parse_calendario } from 'components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones';
import ModalConsultaMensual from './ModalConsultaMensual';
import { handle_error, handle_number_status } from './helper_function';
import ModalEnviarPlanificaciones from './ModalEnviarPlanificaciones';
import ModalEnviarTalentoHumano from './ModalEnviarTalentoHumano';
import { ROL_DELEGADO } from 'Context/SideBarContext';
import { alertService } from 'components/Varios/alert_service';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import ModalCargando from 'components/Varios/ModalCargando';


import "../../../assets/scss/PlanificacionVacacionesDirectivo.scss"



const TITULO_PLANIFICACION_DIRECTIVO_DOCENTE = " PLANIFICACIÓN VACACIONES PERSONAL DOCENTE"
const TITULO_PLANIFICACION_DIRECTIVO_ADMINISTRATIVO = " PLANIFICACIÓN VACACIONES PERSONAL ADMINISTRATIVO"
export const PERSONAL_DOCENTE = "PD"
export const PERSONAL_ACADEMICO = "PA"

export type Rows_Calendario_Directivo = {
    personal: string,
    desde: Date,
    hasta: Date,
    dias: number,
    idpersona: number,
    iddirectivo: number,
    idplanificacion: number,
    estado?: string,
    estadoreplanificacion:string|null,
    observacion?: string
}

export type Rows_Resumen_Directivo = {
    serial?: number,
    id_persona: number,
    iddirectivoasignado: number,
    persona: string,
    dias_pendientes: number,
    dias_planificados: number,
    meses_planificados: Array<string>,
    estadoaprobacion?: string,
    regimenlaboral: string,
    loadministroactualmente: boolean
}

type Calendario_Directivo = {
    Mes: string,
    Orden: number,
    Anio: string,
    Color: string,
    Rows?: Array<Rows_Calendario_Directivo>,
    Show: boolean
    CantidadPersonasPlanicaron: number,
}


type InformacionPlanifVacacionDTO = {
    calendarioPlanificacionUsuario: Array<Rows_Calendario_Directivo>,
    cantidadPersonasPlanifican: number

}
export type Dictionary_Calendario_Directivo = {
    key: string,
    value: InformacionPlanifVacacionDTO
}

export type PrimerDirectivoDTO = {
    nombres: string,
    cantidad_personal_planifica: number,
    cantidad_personal_planificado: number,
    cantidad_personal_noasignadoAlSegundoAprobador: number
}

export type Dictionary_Primer_Aprobador = {
    key: number,
    value: PrimerDirectivoDTO
}

export type Respuesta_PlanificacionVacDirectivo = {
    calendario_directivo: Array<Dictionary_Calendario_Directivo>
    // resumen_directivo : Array<Dictionary_Resumen_Directivo>;
    resumen_directivo: Array<Rows_Resumen_Directivo>
    idpersona: number,
    idlocalidad_dirijo: number,
    anio_planificacion: number,
    tipo_aprobador: string,
    listado_primeros_aprobadores: Array<Dictionary_Primer_Aprobador>
    cantidad_personas_noasignadas: number,
    cantidad_personas_administro: number,
    planificaciones_enviadas_TH: boolean,
    periodoVigente: boolean,
    periodoExtraordinario: boolean
}


export type Datos_Planificacion_Aprobada = {
    datos_planificacion: Array<Planificacion_Vacaciones>
    persona: string,
    idpersona: number,
    tipo_aprobador: string
}

export type Props_PlanificacionVacaciones = {
    tipo_personal: string
}



//Manejo de errores
const function_validar_request = (error: any): number => {
    if (error.response) {
        return error.response.status
    }
    return 0;
}

//Obtener valores para creacion de calendario segun el nombre del mes que se le pasa
function obtener_color_orden(mes: string): Array<string> {
    const listado_mes: Array<string> = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    const color_mes: Array<string> = ["#8FC200", "#44E497", "#44B9FF", "#0073D5", "#3043D5", "#752DFF", "#DD3FDE", "#FF8F95", "#FF8F00", "#FF3400", "#A03400", "#008903"]

    var mes_minuscula = mes.toLowerCase();

    var indice_listado_mes = listado_mes.findIndex((value) => value.toLowerCase() === mes_minuscula);
    if (indice_listado_mes === -1) return ["NULL", "NULL"];
    else {

        return [listado_mes[indice_listado_mes], color_mes[indice_listado_mes], (indice_listado_mes + 1).toString()];
    }


}




const PlanificacionVacaciones: React.FC<Props_PlanificacionVacaciones> = (props: Props_PlanificacionVacaciones) => {

    const [respuestaPlanificacionDirectivo, setrespuestaPlanificacionDirectivo] = useState<Respuesta_PlanificacionVacDirectivo>()
    const [calendarioVacacionesDirectivo, setcalendarioVacacionesDirectivo] = useState<Array<Calendario_Directivo>>([]);
    const [cardsCalendarioDirectivo, setcardsCalendarioDirectivo] = useState<Array<HTMLElement>>([])
    const [tablaResumenDirectivo, settablaResumenDirectivo] = useState<JSX.Element>()
    //Restricciones
    const [unathorized, setunathorized] = useState<boolean>(false);
    //MostrarComponentes
    const [loading, setloading] = useState<boolean>(true);
    const [showModal, setshowModal] = useState<boolean>(false)

    //Para el modal
    const [idPersonaModal, setidPersonaModal] = useState<number>(-1);
    const [estadoPersonaPlanificaModal, setestadoPersonaPlanificaModal] = useState<string>("");
    const [showModalAprobacionTotal, setshowModalAprobacionTotal] = useState<boolean>(false)
    const [showModalEnviarTH, setshowModalEnviarTH] = useState<boolean>(false)
    //Datos para mostrar modal de consulta general de planificacion de meses
    const [showModalConsultaMes, setshowModalConsultaMes] = useState<boolean>(false);
    const [mesConsulta, setmesConsulta] = useState<number>(-1);
    //Datos que se agregan al calendario una vez que se haya aprobada alguna planificacion
    const inicial_datos_planificacion_aprobada: Datos_Planificacion_Aprobada = { datos_planificacion: [], persona: "", idpersona: -1, tipo_aprobador: "" }
    const [datos_planificacion_aprobada, setdatos_planificacion_aprobada] = useState<Datos_Planificacion_Aprobada>(inicial_datos_planificacion_aprobada);
    //Tabla de resumen
    const [filterText, setFilterText] = useState<string>('');
    const [filterSelect, setfilterSelect] = useState<string>('');
    //Boton para enviar planificacion a segundo directivo
    const [mostrarBotonEnviarDirectivo, setmostrarBotonEnviarDirectivo] = useState<boolean>(false)
    //Activar accion de mandar a directivo
    const [enviarDirectivo, setenviarDirectivo] = useState<boolean>(false)
    const [erroresEnviarDirectivo, seterroresEnviarDirectivo] = useState<Array<string>>([])
    const [loadingRespuestaDirectivo, setloadingRespuestaDirectivo] = useState<boolean>(false);
    //Boton para aprobar todas las planificaciones que fueron enviadas por el primer aprobador
    const [mostrarBotonAprobarParcialmente, setmostrarmostrarBotonAprobarParcialmente] = useState<boolean>(false)
    //Boton para enviar todas las planificaciones a talento humano en caso de que esten aprobadas
    const [mostrarBotonEnviarTalentoHumano, setmostrarBotonEnviarTalentoHumano] = useState<boolean>(false)
    // //Conocer si todas las planificaciones se han aprobado en su totalidad
    // const [todaslasPlanificacionesAprobadas, settodaslasPlanificacionesAprobadas] = useState<boolean>(false)
    //Conocer si soy primer o segundo-unico aprobador
    const [tipo_aprobador, settipo_aprobador] = useState<string>("")
    //Listado de primeros aprobadores
    const [listadoPrimerosAprobadores, setlistadoPrimerosAprobadores] = useState<Array<Dictionary_Primer_Aprobador>>([])
    //Indicar que todas las planificaciones se enviaron al segundo directivo
    const [enviadasSegundoDirectivo, setenviadasSegundoDirectivo] = useState<boolean>(false)
    //Indicar si se puede o no enviar planificacion
    const [mostrarbotonEnviarPlanificacionModal, setmostrarbotonEnviarPlanificacionModal] = useState<boolean>(true)

    //Tipo Personal
    const [tipo_personal, settipo_personal] = useState<string>(props.tipo_personal)
    //Conocer si es Delegado
    const [isDelegado, setisDelegado] = useState<boolean>(false)
    //Boton que indica que se esta descargando reporte de resumen
    const [loadingReporteResumen, setloadingReporteResumen] = useState<boolean>(false);

    const compare_calendario_directivo = (a: Dictionary_Calendario_Directivo, b: Dictionary_Calendario_Directivo) => {

        const indice_a: number = +obtener_color_orden(a.key)[2];
        const indice_b: number = +obtener_color_orden(b.key)[2];

        if (indice_a < indice_b) {
            return -1;
        }
        if (indice_a > indice_b) {
            return 1;
        }
        return 0;
    }

    const parsear_respuesta_calendario = (respuesta: Array<Dictionary_Calendario_Directivo>, anio_planificacion: number): Array<Calendario_Directivo> => {
        var array_calendario_planificacion: Array<Calendario_Directivo> = [];
        respuesta.map((datos_calendario_directivo, index_calendario) => {

            const [Mes, Color, Orden] = obtener_color_orden(datos_calendario_directivo.key);
            array_calendario_planificacion.push(
                {
                    Mes,
                    Color,
                    Orden: +Orden,
                    Anio: anio_planificacion.toString(),
                    Show: true,
                    Rows: datos_calendario_directivo.value.calendarioPlanificacionUsuario,
                    CantidadPersonasPlanicaron: datos_calendario_directivo.value.cantidadPersonasPlanifican

                }
            )
        })
        return array_calendario_planificacion;
    }

    const ComponentBuscadorTabla = (): JSX.Element => {

        async function DescargarReporteResumenDirectivo(tipoPersonal: string) {
            setloadingReporteResumen(true);

            if (tipoPersonal !== PERSONAL_ACADEMICO && tipoPersonal !== PERSONAL_DOCENTE) {
                alertService.error("Debe indicar el tipo del personal para el reporte.");
                return
            }
            else {
                var currentUser: UserData = authenticationService.currentUserValue;
                await fetch(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/Reporte/ResumenPlanificaciones/${tipoPersonal}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `KEYESPOL ${currentUser?.token}`
                    },
                    method: "GET"
                })
                    .then(response => {
                        if (response.ok) {
                            response.blob().then(blob => {

                                let url = window.URL.createObjectURL(blob);
                                let a = document.createElement('a');
                                a.href = url;
                                a.download = "ResumenPlanificacionesVacacionesPersonal"  //nombrearchivo
                                a.click();
                            });
                        }
                        else {
                            alertService.error("Ha ocurrido un error inesperado. Intente más tarde");
                        }

                    })
                    .catch(async (error) => {
                        var error_any: any = error;
                        var status: number = handle_error(error_any);
                        switch (status) {
                            case 0 || -1:
                                alertService.error("No ha sido posible contactar con el servido. Intente más tarde");
                                break;
                            case 500:
                                alertService.error("Ha ocurrido un error inesperado. Intente más tarde");
                            case 400:
                                alertService.error("La acción que desea realizar ha cambiado");
                            default:
                                break;
                        }
                    });

            }

            setloadingReporteResumen(false);
        }


        return (
            <div className="subHeaderTable">
                <Row className="justify-content-end ">
                    <Col xl={6} sm={12} className="mb-3 text-right">
                        <select defaultValue="FILTRAR ESTADOS" className="select-tabla-estados " name="select" onChange={(e) => setfilterSelect(e.target.value)}>
                            <option value={"T"} >{"TODOS LOS ESTADOS"}</option>
                            <option value={ESTADO_PENDIENTE}>{"PENDIENTE"}</option>
                            <option value={ESTADO_APROBADO}>{"APROBADO"}</option>
                            <option value={ESTADO_TIENE_RECHAZADAS} >{"RECHAZADO"}</option>
                            {/* <option value={ESTADO_TIENE_RECHAZADAS} >{"TIENE RECHAZADAS"}</option> */}
                            <option value={ESTADO_APROBACION_PARCIAL} >{"APROBADO PARCIALMENTE"}</option>
                            <option value={ESTADO_NO_HA_PLANIFICADO} >{"NO PLANIFICADO "}</option>
                        </select>
                    </Col>
                    <Col xl={6} sm={12} className="text-right mb-3 no-padding">
                        <input
                            value={filterText}
                            className='text-center'
                            onChange={(e) => setFilterText(e.target.value)}
                            placeholder="FILTRAR PERSONAL"
                        />
                    </Col>
                </Row>
                <Row >
                    <Col sm={12} className="no-padding">
                        <Button
                            className='btnEspolAceptar'
                            onClick={() => DescargarReporteResumenDirectivo(props.tipo_personal)}
                        >
                            Descargar Resumen Planificación Vacaciones
                        </Button>
                    </Col>
                </Row>

            </div>

        );
    }

    useEffect(() => {
        if (respuestaPlanificacionDirectivo && (filterText != "" || filterSelect != "")) {
            var filtrado: Array<Rows_Resumen_Directivo> = respuestaPlanificacionDirectivo.resumen_directivo;
            if (filterSelect != "") {

                if (filterSelect === ESTADO_TIENE_RECHAZADAS) {

                    filtrado = filtrado.filter(item => {
                        return item.estadoaprobacion && (item.estadoaprobacion === filterSelect || item.estadoaprobacion === ESTADO_RECHAZADO)
                    })

                }
                else if (filterSelect != "T") {
                    filtrado = filtrado.filter(item => {
                        return item.estadoaprobacion && item.estadoaprobacion === filterSelect
                    })
                }

            }
            if (filterText != "") {
                filtrado = filtrado.filter(item => {
                    return item.persona && item.persona.toLowerCase().includes(filterText.toLowerCase())
                })
            }

            settablaResumenDirectivo(generar_tabla_resumen(filtrado, respuestaPlanificacionDirectivo.tipo_aprobador))

        }
        else if (filterText === "" && respuestaPlanificacionDirectivo) {
            var filtrado: Array<Rows_Resumen_Directivo> = respuestaPlanificacionDirectivo.resumen_directivo;

            if (filterSelect !== "") {
                if (filterSelect !== "T") {
                    filtrado = filtrado.filter(item => {
                        return item.estadoaprobacion && item.estadoaprobacion === filterSelect
                    })
                }

            }
            settablaResumenDirectivo(generar_tabla_resumen(filtrado, respuestaPlanificacionDirectivo.tipo_aprobador))
        }

    }, [filterText, filterSelect]);






    const generar_tabla_resumen = (datos_planificacion_directivo: Array<Rows_Resumen_Directivo>, tipo_aprobador: string) => {

        const identificarestado = (estado: string | undefined) => {
            var valor_retorno = ""
            if (estado) {
                switch (estado.trim()) {
                    case ESTADO_NO_HA_PLANIFICADO:
                        valor_retorno = "AUN NO PLANIFICADO"
                        break;
                    case "PL":
                        valor_retorno = "PLANIFICADO"
                        break;
                    case ESTADO_PENDIENTE:
                        valor_retorno = "PENDIENTE"
                        break;
                    case ESTADO_APROBACION_PARCIAL:
                        valor_retorno = "APROBADO PARCIALMENTE"
                        break;
                    //case ESTADO_APROBACION_PARCIAL:
                    //    valor_retorno = "TIENE RECHAZADAS"
                    //    break;
                    case ESTADO_APROBADO:
                        valor_retorno = "APROBADA"
                        break;
                    case ESTADO_ENVIADO_TALENTO_HUMANO:
                        valor_retorno = "ENVIADO A DTH"
                        break;
                    default:
                        break;
                }
            }
            return valor_retorno
        }

        const campos_estado = (estado: string | undefined, tipo_aprobador: string) => {
            var clase_div = ""
            var texto = ""
            if (estado) {
                switch (estado.trim()) {
                    case ESTADO_NO_HA_PLANIFICADO:
                        texto = "AUN NO PLANIFICADO";
                        clase_div = "persona_sin_planificar";
                        break;
                    case "PL":
                        texto = "PLANIFICADO"
                        clase_div = "persona_planificada";
                        break;
                    case ESTADO_PENDIENTE:
                        texto = "PENDIENTE"
                        clase_div = "persona_pendiente"
                        break;
                    case ESTADO_RECHAZADO:
                        texto = "RECHAZADO"
                        clase_div = "persona_sin_planificar"
                        break;
                    case ESTADO_APROBACION_PARCIAL:
                        texto = "APROBADO PARCIALMENTE"
                        clase_div = "persona_pendiente"
                        break;
                    case ESTADO_TIENE_RECHAZADAS:
                        texto = "TIENE RECHAZADAS"
                        clase_div = "persona_sin_planificar"
                        break;
                    case ESTADO_APROBADO:
                        if (tipo_aprobador === PRIMER_APROBADOR) {
                            texto = "APROBADA POR DIRECTIVO"
                        }
                        else if (tipo_aprobador === SEGUNDO_APROBADOR || UNICO_APROBADOR) {
                            texto = "APROBADA"
                        }
                        clase_div = "persona_aprobada"
                        break;
                    case ESTADO_ENVIADO_TALENTO_HUMANO:
                        texto = "ENVIADO A TALENTO HUMANO"
                        clase_div = "persona_aprobada"
                    default:
                        break;
                }
            }
            return (
                <div className={clase_div}>
                    {texto}
                </div>
            )

        }

        const generar_acciones = (idpersona: number, estado: string | undefined) => {

            const auxiliar_preparar_info = (accion: string) => {

                if (accion === "R")
                    setidPersonaModal(idpersona);
                setestadoPersonaPlanificaModal(estado ? estado : "");


            }

            var estado_normalizado = estado?.trim()
            var solo_segundo_directivo = tipo_aprobador.trim() === SEGUNDO_APROBADOR
            var solo_primer_directivo = tipo_aprobador.trim() === PRIMER_APROBADOR
            var primer_directivo_no_administra_aprobados = solo_primer_directivo && estado_normalizado === ESTADO_APROBADO
            var segundo_directivo_administra_parciales = solo_segundo_directivo && estado_normalizado === ESTADO_APROBACION_PARCIAL
            var puedeadministrar = estado_normalizado && estado_normalizado !== ESTADO_NO_HA_PLANIFICADO
                && !primer_directivo_no_administra_aprobados
            // && (estado_normalizado !== ESTADO_APROBACION_PARCIAL || segundo_directivo_administra_parciales)

            return (
                <React.Fragment>
                    <div className="container_iconos_tabla_directivo">
                        {/* <i className="far fa-check-circle" onClick={() => auxiliar_preparar_info("A")}></i> */}

                        {puedeadministrar &&
                            <i data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ver detalle" className="far fa-list-alt  " onClick={() => auxiliar_preparar_info("R")}></i>
                        }


                    </div>
                </React.Fragment>
            )
        }

        const columns: TableColumn<Rows_Resumen_Directivo>[] = [
            // {
            //     name: '#',
            //     selector: row => row.serial ? row.serial : 0,
            //     maxWidth: '5%',
            //     width: '50px'

            // },
            {
                name: 'Personal',
                selector: row => row.persona,
                sortable: true,
                cell: (row) => {
                    return (
                        <div style={{ textAlign: "left" }}>
                            {row.persona}
                        </div>
                    )
                }

            },
            {
                name: 'Régimen Laboral',
                selector: row => row.regimenlaboral,
                sortable: true,
            },
            {
                name: 'Días pendientes',
                selector: row => row.dias_pendientes,
                sortable: true,


            },
            {
                name: 'Días planificados',
                selector: row => row.dias_planificados,
                sortable: true,




            },
            {
                name: 'Meses planificados',
                selector: row => row.meses_planificados.toString(),
                cell: row => <div data-bs-toggle="tooltip" data-bs-placement="top" title={row.meses_planificados.toString()}>{row.meses_planificados.toString()}</div>

            },
            {
                name: 'Estado',
                selector: row => identificarestado(row.estadoaprobacion),
                cell: (row) => campos_estado(row.estadoaprobacion, tipo_aprobador),
                sortable: true,



            },
            {
                name: 'Acciones',
                cell: (row) => generar_acciones(row.id_persona, row.estadoaprobacion),

            }

        ]

        const compare_rows_resumen = (a: Rows_Resumen_Directivo, b: Rows_Resumen_Directivo) => {
            if (a.persona < b.persona) {
                return -1;
            }
            if (a.persona > b.persona) {
                return 1;
            }
            return 0;
        }

        var datos_planificacion_directivo_ordenado = datos_planificacion_directivo.sort((datosa, datosb) => compare_rows_resumen(datosa, datosb));

        datos_planificacion_directivo_ordenado.forEach((planif, index) => { planif.serial = index + 1; });



        const paginationComponentOptions = {
            rowsPerPageText: 'Filas por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todos',
        };
        const customStyles_tabla = {
            table: {
                style: {
                    // width: "fit-content",
                }
            },
            subHeader: {
                style: {
                    // display: 'flex',
                    // alignItems: 'center'

                },
            },
            headRow: {
                style: {
                    backgroundColor: "#243165",
                    color: "white",
                    fontSize: '1.2em',

                },
                denseStyle: {
                    minHeight: '32px',
                },
            },
            rows: {
                style: {
                    minHeight: '50px', // override the row height
                    fontSize: '1em',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                },
            },
            pagination: {
                style: {
                    // display: 'flex',
                    'justify-content': 'flex-end',
                    color: "#243165",
                    fontSize: '1em',
                    minHeight: '56px',
                    // backgroundColor: theme.background.default,
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    // borderTopColor: theme.divider.default,
                },
            }
        }

        const paginationrows = [5, 10, 15, 20, 25]
        return (
            <DataTable
                columns={columns} data={datos_planificacion_directivo_ordenado}
                striped customStyles={customStyles_tabla}
                subHeaderComponent={ComponentBuscadorTabla()}
                subHeader={true}
                subHeaderAlign={Alignment.RIGHT}
                subHeaderWrap={true}
                pagination paginationComponentOptions={paginationComponentOptions} paginationRowsPerPageOptions={paginationrows} />
        )

    }




    //Seccion Effect
    useEffect(() => {

        var roles_usuario: string[] = authenticationService.currentUserValue.roles_usuario;

        setrespuestaPlanificacionDirectivo(undefined)
        setunathorized(false)
        //Modals
        setshowModal(false)
        setshowModalAprobacionTotal(false)
        setshowModalEnviarTH(false)
        setshowModalConsultaMes(false)
        setmesConsulta(-1)
        setidPersonaModal(-1)

        setestadoPersonaPlanificaModal("")
        //Componentes a mostrar
        setcalendarioVacacionesDirectivo([])
        settablaResumenDirectivo(undefined)
        setcardsCalendarioDirectivo([])
        setmostrarmostrarBotonAprobarParcialmente(false)
        setmostrarBotonEnviarTalentoHumano(false)
        setlistadoPrimerosAprobadores([])
        setenviadasSegundoDirectivo(false)
        setmostrarbotonEnviarPlanificacionModal(true)

        //Tabla
        setFilterText("")
        setfilterSelect("")

        //
        setisDelegado(roles_usuario.includes(ROL_DELEGADO))
        settipo_personal(props.tipo_personal)


    }, [props.tipo_personal])



    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //setloading(true)
        //const obtener_datos_generales_directivo = async () => {
        //    const currentUser = authenticationService.currentUserValue;
        //    try {
        //        const respuesta_request = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/${tipo_personal}`,
        //            {
        //                headers: {
        //                    Authorization: `KEYESPOL ${currentUser?.token}`
        //                }
        //            });
        //        var respuesta: Respuesta_PlanificacionVacDirectivo = respuesta_request.data;

        //        var cantidad_personas_aprobadas_parcialmente = 0;
        //        var cantidad_personas_aprobadas = 0;
        //        var cantidad_personas_enviadas_talento_humano = 0;
        //        var cantidad_personas_que_deben_aprobarse = respuesta.resumen_directivo.length;
        //        var cantidad_personas_que_administra = respuesta.cantidad_personas_administro;
        //        var cantidad_personas_asignadas_otro_directivo = 0;
        //        var id_directivo_administra = respuesta.idpersona;
        //        var cantidad_personas_primeros_deben_aprobar = 0;

        //        respuesta.resumen_directivo.map((row_resumen) => {
        //            if (row_resumen.estadoaprobacion === ESTADO_APROBACION_PARCIAL || row_resumen.estadoaprobacion === ESTADO_APROBADO) {
        //                cantidad_personas_aprobadas_parcialmente++;
        //            }
        //            // if (row_resumen.iddirectivoasignado !== id_directivo_administra && row_resumen.iddirectivoasignado !== 0) {
        //            //     cantidad_personas_asignadas_otro_directivo++;
        //            // }
        //            if (!row_resumen.loadministroactualmente) {
        //                cantidad_personas_asignadas_otro_directivo++;
        //            }
        //            if (row_resumen.estadoaprobacion === ESTADO_APROBADO || row_resumen.estadoaprobacion === ESTADO_ENVIADO_TALENTO_HUMANO) {
        //                cantidad_personas_aprobadas++;
        //            }
        //            if (row_resumen.estadoaprobacion === ESTADO_ENVIADO_TALENTO_HUMANO) {
        //                cantidad_personas_enviadas_talento_humano++;
        //            }
        //        })

        //        settipo_aprobador(respuesta.tipo_aprobador);

        //        //Mostrar botones



        //        var size_lista_primeros_directivos = respuesta.listado_primeros_aprobadores.length
        //        var mostrar_boton_aproba_parcialmente = false;




        //        if (cantidad_personas_aprobadas_parcialmente === cantidad_personas_que_deben_aprobarse && respuesta.tipo_aprobador === PRIMER_APROBADOR) {
        //            setmostrarBotonEnviarDirectivo(true);

        //        }
        //        else if (respuesta.tipo_aprobador === SEGUNDO_APROBADOR && size_lista_primeros_directivos > 0 && respuesta.cantidad_personas_noasignadas === 0) {
        //            mostrar_boton_aproba_parcialmente = true;

        //        }






        //        //Si soy segundo o unico aprobar y todas las planificaciones estan aprobadas, muestro boton de enviar a TH
        //        if ((respuesta.tipo_aprobador === UNICO_APROBADOR || respuesta.tipo_aprobador === SEGUNDO_APROBADOR) && cantidad_personas_enviadas_talento_humano === cantidad_personas_que_administra) {
        //            setmostrarBotonEnviarTalentoHumano(false);
        //        }
        //        else if ((respuesta.tipo_aprobador === UNICO_APROBADOR || respuesta.tipo_aprobador === SEGUNDO_APROBADOR) && (cantidad_personas_aprobadas === cantidad_personas_que_administra || respuesta.periodoExtraordinario)) {
        //            setmostrarBotonEnviarTalentoHumano(true);
        //        }

        //        //Si tiene primeros aprobadores
        //        if (size_lista_primeros_directivos != 0) {
        //            //Pones el state de la lista
        //            setlistadoPrimerosAprobadores(respuesta.listado_primeros_aprobadores);

        //            var cantidad_directivos_aprobaron_todo = 0;
        //            respuesta.listado_primeros_aprobadores.map((diccion_aproba) => {
        //                var pa: PrimerDirectivoDTO = diccion_aproba.value;
        //                cantidad_personas_primeros_deben_aprobar += pa.cantidad_personal_planifica;
        //                if (pa.cantidad_personal_planifica === pa.cantidad_personal_planificado) {
        //                    cantidad_directivos_aprobaron_todo++;
        //                }
        //            })

        //            if (cantidad_directivos_aprobaron_todo !== size_lista_primeros_directivos) {
        //                mostrar_boton_aproba_parcialmente = false;
        //            }


        //        }

        //        setmostrarmostrarBotonAprobarParcialmente(mostrar_boton_aproba_parcialmente);

        //        setrespuestaPlanificacionDirectivo(respuesta);

        //        settablaResumenDirectivo(generar_tabla_resumen(respuesta.resumen_directivo, respuesta.tipo_aprobador))

        //        //VERIFICAR SI TODAS LAS PLANIFICACIONES FUERON ENVIADAS AL SEGUNDO PROVEEDOR
        //        if (respuesta.tipo_aprobador === PRIMER_APROBADOR && cantidad_personas_que_deben_aprobarse === cantidad_personas_asignadas_otro_directivo) {
        //            setenviadasSegundoDirectivo(true);
        //            setmostrarbotonEnviarPlanificacionModal(false);
        //        }
        //        //VERIFICAR SI EXISTE UNA PLANIFICACION ENVIADA A TH
        //        //if (cantidad_personas_enviadas_talento_humano > 0) {
        //        //    setmostrarbotonEnviarPlanificacionModal(false);
        //        //}






        //    } catch (error) {
        //        var status_code: number = function_validar_request(error);
        //        switch (status_code) {
        //            case 401:
        //                setunathorized(true);
        //                break;

        //            default:
        //                break;
        //        }

        //    }
        //    setloading(false);

        //}

        //obtener_datos_generales_directivo();

    }, [tipo_personal])




    useEffect(() => {
        const generar_calendarios_directivo = () => {

            if (respuestaPlanificacionDirectivo) {

                const generar_icon_tabla_mensual = (estado: string | undefined) => {
                    var icono = <i></i>;
                    var clase_aprobar = "far fa-check-circle opcion_aprobar_planificacion"
                    var clase_rechazar = "far fa-times-circle opcion_rechazar_planificacion"
                    var clase_pendiente = "fas fa-ellipsis-h pendiente_icono_tabla_mensual"
                    if (estado != undefined) {

                        if (estado === ESTADO_APROBADO) {
                            // icono = <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobado"></i>;
                            icono = <div className="pendiente_icono_tabla_mensual">APROBADO</div>

                        }
                        else if (estado === ESTADO_RECHAZADO) {
                            // icono = <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazado"></i>
                            icono = <div className="pendiente_icono_tabla_mensual">RECHAZADO</div>

                        }
                        else if (estado.trim() === ESTADO_PENDIENTE) {

                            icono = <div className="pendiente_icono_tabla_mensual">PENDIENTE</div>
                        }
                        else if (estado.trim() === ESTADO_APROBACION_PARCIAL) {
                            icono = <div className="pendiente_icono_tabla_mensual">APROBADO PARCIALMENTE</div>

                        }
                        else if (estado.trim() === ESTADO_ENVIADO_TALENTO_HUMANO) {
                            icono = <div className="pendiente_icono_tabla_mensual">ENVIADO A TALENTO HUMANO</div>
                        }

                        return (
                            <React.Fragment>
                                {icono}
                            </React.Fragment>
                        );
                    }

                }
                const cards_calendario: any = calendarioVacacionesDirectivo.map((datos_calendario_directivo, index_calendario_directivo) => {

                    const cantidadServidoresPlanificaron = datos_calendario_directivo.CantidadPersonasPlanicaron;
                    return (
                        <Col className="mb-5 text-center text-lg-none" xl={4} lg={6} md={6} key={index_calendario_directivo + "calendario_directivo"} >
                            <Card className="card_plan_vaca_directivo">
                                <CardTitle className="card_header_vacaciones"  >
                                    <div className="circle_header" style={{ background: `${datos_calendario_directivo.Color}` }} >
                                        <div className="anio_number">{datos_calendario_directivo.Anio}</div>
                                    </div>
                                    <div className="container_text_card_header_vacaciones">
                                        <span>
                                            {datos_calendario_directivo.Mes}</span>
                                    </div>
                                </CardTitle>
                                <CardBody id="card_boy_calendario_directivo">
                                    <Table bordered className="table_planificacion_vacaciones" >
                                        <thead className="cabeceras_tabla_planificacion_vac">
                                            <tr style={{ borderBottomColor: datos_calendario_directivo.Color }} className="borde_cabeceras_planificacion" >
                                                <th>Personal</th>
                                                {/* <th>Desde</th>
                                                <th>Hasta</th> */}
                                                <th>Días</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {datos_calendario_directivo.Rows?.map((fila, index_row) => {
                                                return (
                                                    <tr key={"row_directivo_planificacion" + index_row} className="rows_tabla_planificacion_vac_directivo">
                                                        <td className="celda_nombres">{function_capitalize(fila.personal.toLowerCase())}</td>
                                                        {/* <td>{fila.desde}</td>
                                                        <td>{fila.hasta}</td> */}
                                                        <td>{fila.dias}</td>
                                                        <td>{generar_icon_tabla_mensual(fila.estado)}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </CardBody>
                                <CardFooter id="parent_footer_calendario_directivo">

                                    {datos_calendario_directivo.CantidadPersonasPlanicaron !== 0 &&
                                        <div className="footer_cantidad_personas_planifican">
                                            En este mes {cantidadServidoresPlanificaron > 1 ? "han" : "ha"} planificado {cantidadServidoresPlanificaron}  {cantidadServidoresPlanificaron > 1 ? "servidores" : "servidor"}. Para ver la lista completa de este mes
                                            <span className="footer_calendario_directivo" style={{ color: datos_calendario_directivo.Color }} onClick={() => setmesConsulta(datos_calendario_directivo.Orden)} > {"presionar aquí"} </span>
                                        </div>
                                    }

                                    {/* <div className="footer_calendario_directivo" style={{ color: datos_calendario_directivo.Color }} onClick={() => setmesConsulta(datos_calendario_directivo.Orden)} >
                                        Ver todo el mes &gt; &gt;
                                    </div> */}

                                </CardFooter>
                            </Card>
                        </Col>
                    )
                })

                setcardsCalendarioDirectivo(cards_calendario);

            }
        }


        if (calendarioVacacionesDirectivo.length > 0) {
            generar_calendarios_directivo();
        }
    }, [calendarioVacacionesDirectivo])

    const compare_Rows_calendario = (a: Rows_Calendario_Directivo, b: Rows_Calendario_Directivo) => {
        if (a.personal < b.personal) {
            return -1
        }
        else if (a.personal > b.personal) {
            return 1
        }
        return 0
    }

    useEffect(() => {
        if (respuestaPlanificacionDirectivo != undefined) {
            const { calendario_directivo, anio_planificacion } = respuestaPlanificacionDirectivo;

            var copia_calendario_directivo = calendario_directivo;
            copia_calendario_directivo.map(diccionario => {
                diccionario.value.calendarioPlanificacionUsuario.sort(compare_Rows_calendario)
            })
            copia_calendario_directivo.sort(compare_calendario_directivo);
            var new_array_calendario_directivo = parsear_respuesta_calendario(copia_calendario_directivo, anio_planificacion);
            setcalendarioVacacionesDirectivo(new_array_calendario_directivo);
        }

    }, [respuestaPlanificacionDirectivo])

    useEffect(() => {
        if (idPersonaModal !== -1 && estadoPersonaPlanificaModal !== "") {

            setshowModal(true);
        }
    }, [idPersonaModal, estadoPersonaPlanificaModal])


    useEffect(() => {
        if (mesConsulta !== -1) {
            setshowModalConsultaMes(true);
        }
    }, [mesConsulta, tipo_aprobador, mostrarBotonEnviarDirectivo])

    useEffect(() => {

        const modificar_respuesta_planificacion_copia = (copia_respuesta_planificacion: Respuesta_PlanificacionVacDirectivo, datos_planificacion_usuario: Datos_Planificacion_Aprobada) => {
            const { datos_planificacion, persona, idpersona } = datos_planificacion_usuario;

            var cantidad_planificaciones_usuario = datos_planificacion.length;
            var cantidad_aprobada = 0;
            var cantidad_rechazada = 0;
            var cantidad_aprobada_parcialmente = 0;


            //MODIFICANDO EL DICCIONARIO CALENDARIO
            datos_planificacion.map((planificacion_usuario) => {
                var fecha_inicio_formateada_iso = new Date(planificacion_usuario.fechainicio).toISOString();
                var fecha_fin_formateada_iso = new Date(planificacion_usuario.fechafin).toISOString();

                var dia_inicio: number = + formatoFecha(fecha_inicio_formateada_iso).split("/")[0];
                var dia_hasta: number = + formatoFecha(fecha_fin_formateada_iso).split("/")[0];
                var indice_mes = +formatoFecha(fecha_inicio_formateada_iso).split("/")[1] - 1;
                const [mes, color_mes] = function_parse_calendario(indice_mes, false);

                if (planificacion_usuario.estado === ESTADO_APROBADO) {
                    if (tipo_aprobador === PRIMER_APROBADOR) {
                        cantidad_aprobada_parcialmente++;
                    }
                    else {
                        cantidad_aprobada++
                    }
                }
                else if (planificacion_usuario.estado === ESTADO_RECHAZADO) {
                    cantidad_rechazada++;
                }

                //Si es el primer aprobador
                if (tipo_aprobador === PRIMER_APROBADOR) {
                    // var indice_busco = copia_respuesta_planificacion.calendario_directivo.findIndex((calendario) => calendario.Key.toLowerCase() === mes.toLowerCase());
                    // if (planificacion_usuario.estado === ESTADO_APROBADO) {
                    //     var indice_row = copia_respuesta_planificacion.calendario_directivo[indice_busco].Value.findIndex((valor_row) => valor_row.personal == datos_planificacion_aprobada.persona)
                    //     copia_respuesta_planificacion.calendario_directivo[indice_busco].Value.splice(indice_row, 1);
                    //     copia_respuesta_planificacion.calendario_directivo.sort((a, b) => compare_calendario_directivo(a, b))
                    // }

                    // var indice_busco_resumen = copia_respuesta_planificacion.resumen_directivo.findIndex((valores_resumen) => valores_resumen. === planificacion_usuario.idplanificacion)

                }

            });

            //Si tiene todos aprobados
            if (cantidad_aprobada === cantidad_planificaciones_usuario) {
                //Si es el primer aprobador
                if (tipo_aprobador === PRIMER_APROBADOR) {
                    var indice_row_busco: number = copia_respuesta_planificacion.resumen_directivo.findIndex((resumen) => resumen.id_persona === idpersona);
                    copia_respuesta_planificacion.resumen_directivo.splice(indice_row_busco, 1);
                }
            }


            // //Si es el primer aprobador
            // if (tipo_aprobador === PRIMER_APROBADOR) {
            //     var indice_busco = copia_respuesta_planificacion.calendario_directivo.findIndex((calendario) => calendario.Key.toLowerCase() === mes.toLowerCase());
            //     if (planificacion_usuario.estado === ESTADO_APROBADO) {
            //         var indice_row = copia_respuesta_planificacion.calendario_directivo[indice_busco].Value.findIndex((valor_row) => valor_row.personal == datos_planificacion_aprobada.persona)
            //         copia_respuesta_planificacion.calendario_directivo[indice_busco].Value.splice(indice_row, 1);

            //     }
            //     copia_respuesta_planificacion.calendario_directivo.sort((a, b) => compare_calendario_directivo(a, b))
            //     console.log(copia_respuesta_planificacion.calendario_directivo);
            //     //MODIFICANDO EL DICCIONARIO PARA LA TABLA
            //     var indice_row_busco: number = copia_respuesta_planificacion.resumen_directivo.findIndex((resumen) => resumen.id_persona == idpersona);
            //     copia_respuesta_planificacion.resumen_directivo.splice(indice_row_busco, 1);

            // }
            // //Si es el segundo aprobador
            // else if (tipo_aprobador === SEGUNDO_APROBADOR) {

            // }
            // //Si es aprobador unico
            // else if (tipo_aprobador === UNICO_APROBADOR) {

            // }




            // if(indice_busco === -1) {
            //     var nuevo_elemento_dictionario:Dictionary_Calendario_Directivo = {
            //         Key:mes,
            //         Value:[{desde: dia_inicio, hasta:dia_hasta,dias:planificaciones_aprobadas.dias_solicitados,personal:persona}]
            //     }

            //     copia_respuesta_planificacion.calendario_directivo.push(nuevo_elemento_dictionario);

            // }
            // else{
            //     if(copia_respuesta_planificacion){

            //         var rows_calendario_quiero = copia_respuesta_planificacion.calendario_directivo[indice_busco].Value;

            //         copia_respuesta_planificacion.calendario_directivo[indice_busco].Value  = [...rows_calendario_quiero , {
            //             desde: dia_inicio, 
            //             hasta:dia_hasta,
            //             dias:planificaciones_aprobadas.dias_solicitados,
            //             personal:persona
            //         }]
            //     }
            // }




        }

        const { datos_planificacion, persona, idpersona } = datos_planificacion_aprobada;
        if (persona !== "" && datos_planificacion.length !== 0 && idpersona !== -1 && respuestaPlanificacionDirectivo) {

            var copia_respuesta_planificacion = respuestaPlanificacionDirectivo;
            modificar_respuesta_planificacion_copia(copia_respuesta_planificacion, datos_planificacion_aprobada);

            var new_array_calendario_directivo: Array<Calendario_Directivo> = parsear_respuesta_calendario(copia_respuesta_planificacion.calendario_directivo, copia_respuesta_planificacion.anio_planificacion);
            setcalendarioVacacionesDirectivo(new_array_calendario_directivo);


            var new_table: JSX.Element = generar_tabla_resumen(copia_respuesta_planificacion.resumen_directivo, tipo_aprobador);
            settablaResumenDirectivo(new_table);

        }

    }, [datos_planificacion_aprobada.persona, datos_planificacion_aprobada.datos_planificacion, datos_planificacion_aprobada.idpersona])





    useEffect(() => {
        if (showModalAprobacionTotal && tipo_aprobador === SEGUNDO_APROBADOR) {

        }
    }, [showModalAprobacionTotal, tipo_aprobador])


    if (unathorized) return <div>No autorizado</div>
    else if (loading) return <Cargando />
    return (
        <div className="content">
            {props.tipo_personal === "PA" && <h4 className="text-center text-md-left"> {TITULO_PLANIFICACION_DIRECTIVO_ADMINISTRATIVO} </h4>}
            {props.tipo_personal === "PD" && <h4 className="text-center text-md-left"> {TITULO_PLANIFICACION_DIRECTIVO_DOCENTE} </h4>}


            <Container fluid={true} id="container_padre_directivoPlanificacion">
                <Row><Col><div className="titulo_tabla text-center text-xl-left mb-2 ">Aprobación/Rechazo de planificaciones por mes</div> </Col></Row>
                <Row >
                    {cardsCalendarioDirectivo.length != 0 && cardsCalendarioDirectivo}
                </Row>
                <Row>

                </Row>



                <Row className="mt-1 mb-1">


                </Row>



                <Row className="">
                    <Col xl={9} xs={12} sm={12} md={8} lg={7} className="mb-sm-2 mb-2"><div className="titulo_tabla">Planificaciones pendientes de aprobar/rechazar individual</div> </Col>
                    {tipo_aprobador !== PRIMER_APROBADOR && !isDelegado &&

                        <Col xl={2} lg={4} sm={12} className="mb-2 text-right">

                            <button disabled={!mostrarBotonEnviarTalentoHumano}
                                className={!mostrarBotonEnviarTalentoHumano ? "btnEnviarTalentoHumanoDisabled" : "btnEnviarTalentoHumano"}
                                onClick={() => setshowModalEnviarTH(true)}>
                                Enviar planificación <br /> a Talento Humano
                            </button>
                        </Col>
                    }
                    {
                        listadoPrimerosAprobadores.length != 0 && !respuestaPlanificacionDirectivo?.planificaciones_enviadas_TH &&
                        <Col xl={9} className="mt-2">
                            {listadoPrimerosAprobadores.map((aprobadores, index) => {
                                var aprobador: PrimerDirectivoDTO = aprobadores.value;
                                var cantidad_no_asignadas = respuestaPlanificacionDirectivo ? respuestaPlanificacionDirectivo.cantidad_personas_noasignadas : -1
                                var cantidad_no_asignadas_delPrimerAprobador = aprobador.cantidad_personal_noasignadoAlSegundoAprobador;
                                if (aprobador.cantidad_personal_planifica !== aprobador.cantidad_personal_planificado) {
                                    return (<div key={"aprobador#" + index}> Aún faltan personas por aprobar parcialmente. Consulte a su primer aprobador {aprobador.nombres} </div>)
                                }
                                else if (aprobador.cantidad_personal_planifica === aprobador.cantidad_personal_planificado && cantidad_no_asignadas > 0 && cantidad_no_asignadas_delPrimerAprobador > 0) {
                                    return (<div key={"aprobador#" + index}> Las planificaciones de  {aprobador.nombres} han sido aprobadas parcialmente, pero aún no han sido enviadas *Solicite que envien las planificaciones* </div>)

                                }
                                else {
                                    return (<div key={"aprobador#" + index}> Todas las planificaciones de {aprobador.nombres} han sido aprobadas parcialmente</div>)
                                }

                            })}
                        </Col>
                    }
                    {mostrarBotonAprobarParcialmente && !mostrarBotonEnviarDirectivo && !isDelegado &&
                        <Col xl={2} lg={4} className="mt-2">
                            <button className="btnEnviarDirectivo" onClick={() => setshowModalAprobacionTotal(true)}>Aprobar todas las planificaciones parciales</button>
                        </Col>
                    }

                    {enviadasSegundoDirectivo && !isDelegado &&
                        <Row className="mt-2">
                            <Col xl={11}>
                                <p className="aviso_planificaciones_enviadas"> Aviso: *Las planificaciones ya han sido enviadas al segundo aprobador*</p>
                            </Col>
                        </Row>
                    }


                    {mostrarBotonEnviarDirectivo && !mostrarBotonAprobarParcialmente && !isDelegado &&
                        <Col xl={2} lg={4} sm={5} md={4} xs={12} className="text-center text-md-none mb-2">
                            <button className="btnEnviarDirectivo" onClick={() => setshowModalAprobacionTotal(true)}>Enviar planificación a directivo</button>
                        </Col>
                    }





                    <Col xl={11} lg={11} sm={12}>
                        {tablaResumenDirectivo}

                    </Col>

                </Row>
                <ModalCargando
                    show={loadingReporteResumen}
                    onClose={() => setloadingReporteResumen(false)}
                    size='sm'
                />
                <ModalDirectivo
                    show={showModal}
                    toogle={() => setshowModal(!showModal)}
                    idpersona={idPersonaModal}
                    onClose={() => setidPersonaModal(-1)}
                    tipo_aprobador={tipo_aprobador}
                    estado_persona_planificaciones={estadoPersonaPlanificaModal}
                    mostrar_boton_enviar={mostrarbotonEnviarPlanificacionModal}
                    propagar_Aprobado={(planificacionPropagada: Datos_Planificacion_Aprobada) => setdatos_planificacion_aprobada(planificacionPropagada)}
                    isDelegado={isDelegado}
                />
                <ModalConsultaMensual
                    show={showModalConsultaMes}
                    toogle={() => setshowModalConsultaMes(!showModalConsultaMes)}
                    mes_consulta={mesConsulta}
                    onClose={() => setmesConsulta(-1)}
                    anio={respuestaPlanificacionDirectivo?.anio_planificacion}
                    color={mesConsulta !== -1 ? obtener_color_orden(parseo_mes[mesConsulta - 1])[1] : ""}
                    tipo_aprobador={tipo_aprobador}
                    mostrar_boton_enviar={mostrarbotonEnviarPlanificacionModal}
                    tipo_personal={tipo_personal}
                    isDelegado={isDelegado}


                />
                <ModalEnviarPlanificaciones

                    show={showModalAprobacionTotal}
                    toogle={() => setshowModalAprobacionTotal(!showModalAprobacionTotal)}
                    onClose={() => setshowModalAprobacionTotal(false)}
                    tipo_aprobador={tipo_aprobador}
                    tipo_personal={tipo_personal}

                />

                {
                    respuestaPlanificacionDirectivo &&
                    <ModalEnviarTalentoHumano
                        show={showModalEnviarTH}
                        toogle={() => setshowModalEnviarTH(!showModalEnviarTH)}
                        onClose={() => setshowModalEnviarTH(false)}
                        tipo_aprobador={tipo_aprobador}
                        tipo_personal={tipo_personal}
                        periodoExtraordinario={respuestaPlanificacionDirectivo.periodoExtraordinario}
                        informacionPersonal={respuestaPlanificacionDirectivo.resumen_directivo}
                    />
                }

            </Container>
        </div>
    )
}
export default PlanificacionVacaciones;
